module.exports = __webpack_public_path__ + "img/66_10.5a9694b0.png";